<template>
  <!-- ROTATING MESSAGES -->
  <div class="info" ref="info">Your only job is to FIGURE IT OUT.</div>
</template>

<script>
export default {
  name: "DashboardMotivation",
  data() {
    return {
      words: [
        "Your only job is to FIGURE IT OUT.",
        "So will you do what it takes?",
        "Or will bitch and complain about it?",
        "And make up excuses?",
        "Or will you OWN IT UP?",
        "And TAKE FULL RESPONSIBILITY?",
        "And FIND A WAY?",
        "To SOLVE IT",
        "To MAKE IT WORK",
        "And FIGURE IT OUT?",
        "No matter what it takes?",
        "Two realities.",
        "In one. You get yourself together. And you figure it the fuck out.",
        "In the other. You don't.",
        "Which is it going to be?",
        "Which reality are you deciding to live in?",
      ],
      currentStep: 0,
      oldWord: "",
    };
  },
  mounted() {
    setTimeout(this.changeWord, 600);
  },
  methods: {
    changeWord() {
      this.oldWord = this.$refs.info.innerHTML;

      // check if there is a word atm or not
      if (this.oldWord.length < 1) {
        if (this.currentStep !== this.words.length - 1) {
          this.currentStep++;
        } else {
          this.currentStep = 0;
        }
        this.addNextWord();
      } else {
        setTimeout(this.deleteWord, 600);
      }
    },

    deleteWord() {
      this.$refs.info.innerHTML = "";
      //   //   let WordLength = this.oldWord.length;
      let currentWord = this.$refs.info.innerHTML;
      let currentLength = currentWord.length;

      //   // The word is deleted so, start adding in the new one
      if (currentLength < 1) {
        this.changeWord();
        return;
      }

      //   // Remove a charachter
      //   this.$refs.info.innerHTML = currentWord.substring(0, currentLength - 1);

      //   this.deleteWord();
    },

    addNextWord() {
      let currentWord = this.$refs.info.innerHTML;
      let currentLength = currentWord.length;
      let nextWord = this.words[this.currentStep];
      let nextWordLength = nextWord.length;

      if (currentLength === nextWordLength) {
        this.changeWord();
        return;
      }

      // add a charachter
      this.$refs.info.innerHTML = nextWord.substring(0, currentLength + 1);

      setTimeout(this.addNextWord, 100);
    },
  },
};
</script>

<style scoped>
.info {
  font-size: 50px;
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: center;
  height: 100%;
  background-color: black;
  color: white;
}
</style>